export default __webpack_public_path__ + "static/media/UMCABG.2043e4c9.jpg";